
// url  => file
function urlToFile(url,index,cb) {
    // url = 'https://box-filestorage-uat.niohome.com/api/objects/download?slug=MTA2MTYyMDM1NDI1&token=5d10a8f6e8be0997264974y5tj';
    let img = new Image();
    img.setAttribute("crossOrigin",'Anonymous')
    img.src = url;
    let fullFileName = url.substr(url.lastIndexOf('/') + 1),   //带格式的文件名
        fileName = 'file00' + index,
        fileType = fullFileName.lastIndexOf('.') !== -1 ? fullFileName.substr(fullFileName.lastIndexOf('.') + 1) : '';  //文件格式，如果没有 .   则没有文件类型
    img.onload = ()=> {
        let base64 = urlToBase64(img)
        // let file = base64 ? base64toFile(base64,fileName) : base64;
        cb && cb(base64? base64:'跨域')


        // //这里对base64串进行操作，去掉url头，并转换为byte
        // let data = urlToBase64(img)
        // var text = window.atob(data.split(",")[1]);
        // var ab = new ArrayBuffer(text.length);
        // var ia = new Uint8Array(ab);
        // for (var i = 0; i < text.length; i++) {
        //     ia[i] = text.charCodeAt(i);
        // }
        // console.log(text);
        // console.log(ab);
        // console.log(ia);
        // var blob = new Blob([ab], {type: text});
        // return false
    };
}

function urlToBase64(img) {
    let canvas = document.createElement('canvas');
    canvas.height = img.height;
    canvas.width = img.width;
    let ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, img.width, img.height);
    try {
        let base64url = canvas.toDataURL('image/jpeg',0.1);
        return base64url;
    }catch (e) {
        return false
    }
}


// base64  => File
function base64toFile(dataurl, fileName) {

    let arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        // bstr = arr[1],
        n = bstr.length,
        u8arr = new Uint8Array(n);
    console.log(arr);
    console.log(mime);
    console.log(bstr);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    console.log(u8arr);
    let theFile =  new File([u8arr], fileName, { type: mime });
    // theFile.lastModified = Date.now();
    // theFile.lastModifiedDate = new Date(theFile.lastModified);
    // theFile.name = fileName;
    // theFile.webkitRelativePath = '';
    return theFile
}




export default urlToFile



// WEBPACK FOOTER //
// ./src/utils/urlToBase64.js